import api from '../config/api';

const brandService = {
  /** Public store list (active only). */
  async getActiveForStore() {
    const response = await api.get('/api/brands');
    return response.data;
  },

  /** Admin dashboard: all brands. */
  async getAll() {
    const response = await api.get('/api/brands/admin/all');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/brands/${id}`);
    return response.data;
  },

  async create(brandData) {
    const response = await api.post('/api/brands', brandData);
    return response.data;
  },

  async update(id, brandData) {
    const response = await api.put(`/api/brands/${id}`, brandData);
    return response.data;
  },

  async setStoreVisibility(id, visible) {
    const response = await api.patch(`/api/brands/${id}/store-visibility`, { visible });
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/api/brands/${id}`);
    return response.data;
  },
};

export default brandService;
